"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const configuration_1 = require("@common/configuration");
const jwtDecode = require("jwt-decode");
class TokenValidator {
    /**
     * Validate the basic format of the JWT token
     */
    static isValidFormat(token) {
        if (!token || typeof token !== "string") {
            return false;
        }
        // Verify that the token has the correct format (3 parts separated by dots)
        const parts = token.split(".");
        if (parts.length !== 3) {
            return false;
        }
        return true;
    }
    /**
     * Validate that the token has not expired
     */
    static isNotExpired(token) {
        try {
            const decoded = jwtDecode(token);
            const currentTime = Math.floor(Date.now() / 1000);
            if (!decoded.exp) {
                return false;
            }
            return decoded.exp > currentTime;
        }
        catch (_a) {
            return false;
        }
    }
    /**
     * Validate that the token has the correct audience for acquisitions
     */
    static hasCorrectAudience(token, expectedAudience) {
        try {
            const decoded = jwtDecode(token);
            const audience = expectedAudience || configuration_1.Configuration.acqBackendConfig().audience;
            // The audience can be a string or an array
            if (Array.isArray(decoded.aud)) {
                return decoded.aud.includes(audience);
            }
            return decoded.aud === audience;
        }
        catch (_a) {
            return false;
        }
    }
    /**
     * General token validations
     */
    static validateToken(token, options) {
        var _a;
        const errors = [];
        // Validate format
        if (!this.isValidFormat(token)) {
            errors.push("Invalid JWT format");
        }
        // Validate expiration
        if (!this.isNotExpired(token)) {
            errors.push("Token has expired");
        }
        // Validate audience
        if (!this.hasCorrectAudience(token, (_a = options) === null || _a === void 0 ? void 0 : _a.expectedAudience)) {
            errors.push("Invalid audience");
        }
        return {
            isValid: errors.length === 0,
            errors,
        };
    }
    /**
     * Get token information for debugging
     */
    static getTokenInfo(token) {
        try {
            return jwtDecode(token);
        }
        catch (_a) {
            return null;
        }
    }
}
exports.TokenValidator = TokenValidator;
//# sourceMappingURL=token-validator.js.map